import { HOST_BASE_URL } from 'infra/constants'
import TagManager from 'react-gtm-module'

interface KakaoShareParams {
  title: string
  description: string
  imageUrl: string
  link: string
  btnTitle: string
}

export const getKakaoShareParams = ({
  title,
  description,
  imageUrl,
  link,
  btnTitle,
}: KakaoShareParams) => {
  return {
    title,
    description,
    imageUrl: `${HOST_BASE_URL}${imageUrl}`,
    link: `${HOST_BASE_URL}${link}`,
    btnTitle,
  }
}

declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Kakao: any //  kakao share api
  }
}

export const shareKakao = ({
  title,
  description,
  imageUrl,
  link,
  btnTitle,
}: KakaoShareParams) => {
  TagManager.dataLayer({
    dataLayer: {
      event: 'share_kakao',
      clickText: '카카오톡 공유 아이콘',
    },
  })
  window.Kakao.Share.sendDefault({
    objectType: 'feed',
    content: {
      title,
      description,
      imageUrl,
      link: {
        mobileWebUrl: link,
        webUrl: link,
      },
    },
    buttons: [
      {
        title: btnTitle,
        link: {
          mobileWebUrl: link,
          webUrl: link,
        },
      },
    ],
  })
}
